export enum ColumnAligment {
    Left = 'left',
    Center = 'center',
    Right = 'right'
}
